<template>
  <!-- Модальный онбординг при первом открытии редактора маршрутов.
       "Больше не показывать" запоминается в localStorage. -->
  <div
    class="fixed inset-0 z-[120] flex items-center justify-center bg-ink/50 px-4"
    role="dialog"
    aria-modal="true"
    aria-labelledby="route-editor-onboarding-title"
    @keydown.esc="finish"
  >
    <div class="w-full max-w-sm max-h-[88dvh] overflow-y-auto paper-card p-5">
      <h2 id="route-editor-onboarding-title" class="text-[16px] font-semibold mb-1">{{ t('map.routeEditor.onboardingTitle') }}</h2>
      <p class="text-[12.5px] text-[hsl(var(--muted-foreground))] mb-3">{{ t('map.routeEditor.onboardingIntro') }}</p>

      <ul class="space-y-2.5 mb-4">
        <li v-for="step in steps" :key="step.key" class="flex gap-3 items-start">
          <span class="shrink-0 w-8 h-8 rounded-md bg-[hsl(var(--primary)/0.12)] text-[hsl(var(--primary))] flex items-center justify-center">
            <component :is="step.icon" class="w-[18px] h-[18px]" :stroke-width="1.8" />
          </span>
          <span class="text-[12.5px] leading-snug">
            <strong class="font-semibold">{{ t(`map.routeEditor.onboarding.${step.key}.title`) }}.</strong>
            {{ t(`map.routeEditor.onboarding.${step.key}.text`) }}
          </span>
        </li>
      </ul>

      <label class="flex items-center gap-2 text-[12.5px] mb-3 cursor-pointer select-none">
        <input v-model="dontShowAgain" type="checkbox" class="w-4 h-4 accent-[hsl(var(--primary))]" />
        {{ t('map.routeEditor.dontShowAgain') }}
      </label>

      <button
        type="button"
        class="w-full h-10 rounded-md bg-[hsl(var(--primary))] text-white text-[13px] font-semibold hover:bg-[hsl(158,38%,30%)] transition-colors"
        @click="finish"
      >{{ t('map.routeEditor.gotIt') }}</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, type Component } from "vue";
import { useI18n } from "vue-i18n";
import { Eraser, Magnet, MousePointer2 } from "lucide-vue-next";
import LinePlusIcon from "./icons/LinePlusIcon.vue";
import PinPlusIcon from "./icons/PinPlusIcon.vue";

const emit = defineEmits<{
  (e: "close", dontShowAgain: boolean): void;
}>();

const { t } = useI18n();
const dontShowAgain = ref(false);

const steps: { key: string; icon: Component }[] = [
  { key: "line", icon: LinePlusIcon },
  { key: "point", icon: PinPlusIcon },
  { key: "erase", icon: Eraser },
  { key: "magnet", icon: Magnet },
  { key: "edit", icon: MousePointer2 },
];

const finish = () => emit("close", dontShowAgain.value);
</script>
